<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <div class="font-weight-bold">
    Preview of First Week
  </div>
  <program-week-preview [week]="firstWeek"></program-week-preview>
</div>
